
export default {
  data() {
    return {
      daterange: [],
      tableData: [
        {
          season_type: '요금타입',
          season_name: 'Option1',
          season_term: ['2024-01-01', '2024-03-03'],
          season_treaty: '',
        },
        {
          season_type: '요금타입',
          season_name: 'Option2',
          season_term: ['2024-01-01', '2024-03-03'],
          season_treaty: '',
        },
      ],
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: 'Last month',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        },
        {
          text: 'Last 3 months',
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        },
        ],
      },
      options: [{
        value: 'Option1',
        label: '준성수기',
      }, {
        value: 'Option2',
        label: '성수기',
      }, {
        value: 'Option3',
        label: '극성수기',
      }],
      value: '',
    };
  },
  methods: {
    addNewRow(): void {
      // 기간추가 버튼 클릭 시 호출되는 메서드
      const newRow = {
        season_type: '요금타입',
        season_name: '', // 빈 값으로 시작
        season_term: [], // 빈 값으로 시작
        season_treaty: '',
      };

      // 테이블 데이터에 새로운 행 추가
      // this.tableData.push(newRow);
    },
    removeRow(index: any): void {
    // 삭제 버튼 클릭 시 호출되는 메서드
      console.log(index);
      // this.tableData.splice(index, 1); // 해당 인덱스의 행을 삭제
    },
  },
};
